const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/labReports/updateLabSingleReportHandlers.ts';
import Imm from 'immutable';
import { incCounter, decCounter } from '../../utils/reducerUtils';
import { IKisApiHandlersMap } from '../../defs/actionTypes';
import { UpdateLabSingleReportAction } from '../../actions/labReportsActions';
import { Logger } from '../../services/KisLoggerService';
import { putLabSingleRepIntoState } from '../../utils/labReportUtils';

const Log = Logger('labReports/updateLabSingleReport');

export const updateLabSingleReportHandlers: IKisApiHandlersMap<UpdateLabSingleReportAction> = {
    pending: (state, action) => {
        const repId = `${action.meta.sender}_${action.meta.reportnr}`;
        return incCounter(state, ['loading', 'singleReports', repId]);
    },
    success: (state, action) => {
        const repId = `${action.meta.sender}_${action.meta.reportnr}`;
        let rec = Imm.fromJS(action.payload);
        const patnr = rec.get('PATNR');

        if (!patnr) {
            Log.error(`Report with missing PATNR: ${repId}`);
        } else {
            if (action.meta.etag) {
                rec = rec.set('ETAG', action.meta.etag);
            }

            state = putLabSingleRepIntoState(state, rec, patnr);
        }

        return decCounter(state, ['loading', 'singleReports', repId]);
    },
    failure: (state, action) => {
        Log.warn('Failed to update report!', action);
        const repId = `${action.meta.sender}_${action.meta.reportnr}`;
        return decCounter(state, ['loading', 'singleReports', repId]);
    },
};
